<template>
    <div id="code_promo" class="popin-modal centered" v-show="isPopinDisplayed" v-observe-visibility="{ callback: popin_codepromoDisplayed_callback }">
        <div class="popin-container">
            <div class="popin-closure" v-on:click="popin_codepromoClosed">
                <div class="arrow">X</div>
            </div>
            <div class="popin">
                <div class="popin-content">
                    <span class="title">Création d'un code promo</span>
                    <div class="popin-content-container code_promo-infos" v-if="currentPopinName == 'codepromo-infos'">
                        <div class="form-infos">
                            <div class="input-group">
                                <div class="input-left">
                                    <span>Code<span class="mandatory">*</span></span>
                                    <input type="text" length="8" v-model="formCodePromoInfos_code" v-bind:class="formCodePromoInfos_bindClass('formCodePromoInfos_code')" />
                                </div>
                            </div>

                            <div class="input-group">
                                <div class="input-left">
                                    <span>Type<span class="mandatory">*</span></span>
                                    <select v-model="formCodePromoInfos_amountType" v-bind:class="formCodePromoInfos_bindClass('formCodePromoInfos_amountType')">
                                        <option value="CURRENCY">Montant</option>
                                        <option value="DISCOUNT">Réduction</option>
                                    </select>
                                </div>
                            </div>

                            <div class="input-group">
                                <div class="input-left">
                                    <span>Valeur<span class="mandatory">*</span></span>
                                    <input type="number" min="1" v-model="formCodePromoInfos_amountValue" v-bind:class="formCodePromoInfos_bindClass('formCodePromoInfos_amountValue')" />
                                </div>
                            </div>

                            <div class="input-group">
                                <div class="input-left">
                                    <span>Nombre d'utilisations</span>
                                    <input type="number" min="0" v-model="formCodePromoInfos_maxUsage" v-bind:class="formCodePromoInfos_bindClass('formCodePromoInfos_maxUsage')" />
                                </div>
                            </div>

                            <div class="input-group">
                                <div class="input-full">
                                    <span>Message à ajouter dans l'e-mail de confirmation</span>
                                    <textarea v-model="formCodePromoInfos_emailWording" />
                                </div>
                            </div>

                            <div class="form-submit">
                                <span class="form-error">{{ formCodePromoInfos_error }}</span>
                                <button v-on:click="creer_buttonClicked">Créer</button>
                            </div>
                        </div>
                    </div>

                    <div class="popin-content-container code_promo-process" v-else-if="currentPopinName == 'codepromo-process'">
                        <span v-html="codepromoProcess_message"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import anime from 'animejs/lib/anime.es';
import axios from 'axios';

export default {
    name: "CodePromo",
    components: {},
    data: () => ({
        // popin parameters
        isPopinDisplayed: false,
        currentPopinName: 'codepromo-infos',
        // form parameters
        formCodePromoInfos_code: null,
        formCodePromoInfos_amountType: null,
        formCodePromoInfos_amountValue: null,
        formCodePromoInfos_maxUsage: null,
        formCodePromoInfos_emailWording: null,
        formCodePromoInfos_isSubmit: false,
        formCodePromoInfos_error: null,
        formCodePromoInfos_errorFields: [],
        // process step
        codepromoProcess_message: null
    }),
    methods: {
        performCodePromo: function() {
            this.currentPopinName = 'codepromo-process';
            this.codepromoProcess_message = 'Merci de patienter pendant la création du code promo...';

            var token = localStorage.getItem('admin-token');
            axios.post('https://api.lockquest.fr/voucher_code', {
                action: 'register',
                data: {
                    code: this.formCodePromoInfos_code,
                    amount_type: this.formCodePromoInfos_amountType,
                    amount_value: this.formCodePromoInfos_amountValue,
                    max_usage: this.formCodePromoInfos_maxUsage,
                    email_wording: this.formCodePromoInfos_emailWording
                }
            }, {
                headers: {
                    'Authorization': `Basic ` + token,
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then((response) => {
                this.codepromoProcess_message = 'Le code promo a été créé !<br/>';
                setTimeout(function() {
                    document.location.reload();
                }, 1500);
            }).catch((error) => {
                this.codepromoProcess_message = 'Une erreur est survenue.';
            }).then(() => {
                this.formCodePromoInfos_isSubmit = false;
            });
        },
        creer_buttonClicked: function(event) {
            this.formCodePromoInfos_isSubmit = true;
            this.formCodePromoInfos_errorFields = [];

            if (!this.formCodePromoInfos_code) {
                this.formCodePromoInfos_errorFields.push('formCodePromoInfos_code');
                this.formCodePromoInfos_bindClass('formCodePromoInfos_code');
            }

            if (!this.formCodePromoInfos_amountType) {
                this.formCodePromoInfos_errorFields.push('formCodePromoInfos_amountType');
                this.formCodePromoInfos_bindClass('formCodePromoInfos_amountType');
            }

            if (!this.formCodePromoInfos_amountValue) {
                this.formCodePromoInfos_errorFields.push('formCodePromoInfos_amountValue');
                this.formCodePromoInfos_bindClass('formCodePromoInfos_amountValue');
            }

            var errorFound = null;
            if (this.formCodePromoInfos_errorFields.length > 0) {
                errorFound = 'Veuillez remplir les champs indiqués en rouge avant de valider';
            }

            if (errorFound) {
                this.formCodePromoInfos_error = errorFound;
                this.formCodePromoInfos_isSubmit = false;

                return false;
            } else {
                this.performCodePromo();
            }
        },
        formCodePromoInfos_bindClass: function(form_dataField) {
            return { 'has-error': this.formCodePromoInfos_errorFields.includes(form_dataField) };
        },
        popin_codepromoDisplayed_callback(visible, entry) {
            if (!visible) {
                return;
            }

            var popin_container = document.querySelector('div#code_promo.popin-modal > div.popin-container');
            var popin_container_position = popin_container.getBoundingClientRect();

            var self = this;
            anime({
                targets: 'div#code_promo.popin-modal > div.popin-container',
                opacity: [0, 1],
                duration: 250,
                easing: 'linear'
            });
        },
        popin_codepromoDisplayed: function() {
            this.isPopinDisplayed = true;
        },
        popin_codepromoClosed: function(event) {
            var popin_container = document.querySelector('div#code_promo.popin-modal > div.popin-container');
            var popin_container_position = popin_container.getBoundingClientRect();

            var self = this;
            anime({
                targets: 'div#code_promo.popin-modal > div.popin-container',
                opacity: [1, 0],
                duration: 250,
                easing: 'linear',
                complete: function(anim) {
                    self.isPopinDisplayed = false;
                    self.currentPopinName = 'codepromo-infos';

                    self.formCodePromoInfos_code = null;
                    self.formCodePromoInfos_amountType = null;
                    self.formCodePromoInfos_amountValue = null;
                    self.formCodePromoInfos_maxUsage = null;
                    self.formCodePromoInfos_emailWording = null;
                    self.formCodePromoInfos_isSubmit = false;
                    self.formCodePromoInfos_error = null;
                    self.formCodePromoInfos_errorFields = [];

                    self.codepromoProcess_message = null;
                }
            });
        }
    }
}
</script>